<div class="modal-drop" *ngIf="isOpen">
    <ng-container [ngTemplateOutlet]="template"></ng-container>
</div>
<div class="modal-bg-click" *ngIf="isOpen" (click)="closeModal()">
</div>
<ng-template #template>
    <div class="modal-content-drop">
        <ng-content></ng-content>
    </div>
</ng-template>